import { getTimeView, getCurrentDateTime, genMsgId } from "./libs.js";
import hostMap from "./hostMap.js";
import { doQuestionEventHandler, initInteractiveElsEvents, getSpecialViewFromMsg } from "./toolsHandlers.js";
import specialViewMap from "./specialViewMap.js";


function scrollMsgsContainerDown() {
	const container = document.querySelector(".chat-container");
	container.scrollTo({
		top: container.scrollHeight,
		behavior: 'smooth'
	});
}

export { scrollMsgsContainerDown };

export function resetChat() {
	localStorage.removeItem("chatId");
	localStorage.removeItem("chat");
	localStorage.removeItem("user_rating");
}

export function getChatId() {
	chatId = localStorage.getItem("chatId");
	if(!chatId) {
		chatId = Math.floor(Math.random() * (99999999 - 1000000 + 1)) + 1000000;
		localStorage.setItem("chatId", chatId);
	}

	return chatId;
}

export function showFreqQuests() {
	const freqQuests = specialViewMap.frequentlyQuestions({
		questions: [
			"Мені потрібна допомога у виборі засобу догляду",
			"Які умови співпраці?",
			"Я хочу записатись на курс",
			"Де можна отримати консультацію?",
			"Який статус мого замовлення?"
		]
	});

	document.querySelector(".chat-container").appendChild(freqQuests);
	scrollMsgsContainerDown();
	updateMsgHistory();
}

export async function sendMessages(msgid, message, onChunk) {
	url = AISERV;

	message["site"] = SITENAME;

	try {
		const response = await fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({ action: "kitan", message })
		});

		if (!response.ok) {
			throw new Error(`Ошибка при отправке: ${response.status} ${response.statusText}`);
		}

		const reader = response.body.getReader();
		const decoder = new TextDecoder("utf-8");
		let buffer = "";

		while (true) {
			const { done, value } = await reader.read();
			if (done) break;

			buffer += decoder.decode(value, { stream: true });

			let lines = buffer.split("\n");
			buffer = lines.pop(); // последний может быть неполной строкой

			for (const line of lines) {
				if (!line.trim()) continue;

				try {
					const data = JSON.parse(line);
					if (onChunk) onChunk(data, msgid); // вызвать обработчик
				} catch (e) {
					console.warn("Ошибка разбора JSON:", e, line);
				}
			}
		}

		if (buffer) {
			try {
				const final = JSON.parse(buffer);
				if (onChunk) onChunk(final);
			} catch (e) {
				console.warn("Ошибка разбора последнего чанка:", e, buffer);
			}
		}

	} catch (error) {
		console.error("Ошибка при отправке сообщений:", error);
	}
}

export function prepareUserMessage(text) {
	return {
		message: {
			id: 1,
			date: getCurrentDateTime(),
			text: text,
			reply_to_message: null,
			entities: null,
			photo: null,
			document: null,
			voice: null,
			audio: null,
			video: null,
			sticker: null,
			caption: null
		},
		author: {
			id: 1,
			username: '',
			first_name: '',
			last_name: '',
			title: null,
			type: 'user'
		},
		is_forwarding: false,
		origin: {
			from: 'kitan_bot',
			chat_id: getChatId()
		}
	}
}

export function updateMsgHistory() {
	const chat = document.querySelector(".chat-container");
	localStorage.setItem("chat", chat.innerHTML);
}

export function restoreMsgStorage() {
	const chat = document.querySelector(".chat-container");
	let content = localStorage.getItem("chat");
	if(content) {
		chat.innerHTML = content;
		initInteractiveElsEvents(chat);

		updateMsgHistoryFromServer();
		updateMsgHistory();
		scrollMsgsContainerDown();

		return true;
	}

	return false;
}

export function updateMsgContent(mid, msgtext) {
	const msg = document.querySelector(`.assistant#${mid}`);
	msg.classList.remove("state-waiting");

	msg.querySelector(".bubble").innerHTML = msgtext;
	updateMsgHistory();
	scrollMsgsContainerDown();
}

export function removeMsg(mid) {
	const msg = document.querySelector(`.assistant#${mid}`);
	msg.remove();
	updateMsgHistory();
}

export function makeAssistantMsg() {
	const msg = createRenderBubble("assistant", true, "");

	const chat = document.querySelector(".chat-container");
	chat.appendChild(msg.message);
	scrollMsgsContainerDown();

	updateMsgHistory();

	return msg.id;
}

export function createRenderBubble(type, isFirst, msgtext, mid, time) {
	time = time || getTimeView();
	mid = mid || genMsgId();

	waitingLoader = `
		<span class="waiting">
			<span></span>
			<span></span>
			<span></span>
		</span>
	`;

	msgtext = msgtext || waitingLoader;

	const additionalCls = [];
	let icon = "";
	if(type == "user") {
		additionalCls.push("user");
		icon = `
			<svg class="kb-icon" width="16" height="16">
				<use href="#kb-user"></use>
			</svg>
		`;
	} else {
		additionalCls.push("agent");
		additionalCls.push("assistant");
		if(msgtext == waitingLoader) {
			additionalCls.push("state-waiting");
		}
		icon = `
			<svg class="kb-icon" width="32" height="32">
				<use href="#kb-redes-sm-avatar"></use>
			</svg>
		`;
	}

	const classes = additionalCls.join(" ");
	const msg = `
		<div class="message ${classes}" id="${mid}">
			<div class="leftside">
				<div class="avatar">
					${icon}
				</div>
			</div>

			<div class="rightside">
				<div class="kb-card bubble first">
					
				</div>
				<div class="foot">
					<span class="timestamp">${time}</span>
				</div>
			</div>
		</div>
	`;

	const cont = document.createElement("DIV");
	cont.innerHTML = msg;
	if(typeof msgtext == "object"){
		cont.querySelector(".bubble").appendChild(msgtext);
	}
	else {
		cont.querySelector(".bubble").innerHTML = msgtext;
	}

	return {
		"id": mid,
		"message": cont.querySelector(".message")
	}
}

export function createNewChat() {
	let els = document.querySelectorAll(".chat-container > div");
	for(let i=0; i<els.length; i++) {
		els[i].remove();
	}

	resetChat();

	const msgid = makeAssistantMsg();
	sendMessages(
		msgid,
		prepareUserMessage("/start"), 
		function(resp, msgid){
			if(resp["status"] != "done") {
				return;
			}
			
			let content = marked.parse(resp["content"]).trim();
			updateMsgContent(msgid, content);
			const freqAsks = specialViewMap.frequentlyAsked({
				questions: [
					"Партнерство",
					"Освіта",
					"Статус замовлень",
					"Акції/промо",
				]
			});
			document.querySelector(".chat-container").appendChild(freqAsks);
			scrollMsgsContainerDown();
			updateMsgHistory();
		}
	);
}

export function updateMsgHistoryFromServer() {
	const chatId = localStorage.getItem("chatId");
	if(!chatId) {
		return false;
	}

	doAction("chat.update", {
		"chat_id": chatId
	}, resp => {
		console.log(resp);
		if(!resp.messages.length) {
			return
		}

		const chat = document.querySelector(".chat-container");
		chat.innerHTML = "";
		
		let i=0;
		for(let message of resp.messages) {
			let specialViewContent = getSpecialViewFromMsg(message.content);
			let content = message.content.split("front_special_view")[0].trim();

			const time = getTimeView(message.create_at);

			if(content.length) {
				content = marked.parse(content).trim();
				const msg = createRenderBubble(message.role, true, content, message.id, time);
				chat.appendChild(msg.message);
			}

			if(specialViewContent) {
				if(
					content.length &&
					(specialViewContent.querySelector(".kb-product-card")
					|| specialViewContent.querySelector(".single-btn"))
				) {
					const amsgs = document.querySelectorAll(".chat-container .message.agent.assistant");
					amsgs[amsgs.length - 1].querySelector(".rightside").appendChild(specialViewContent);
				} else {
					document.querySelector(".chat-container").appendChild(specialViewContent);
				}
			}

			if(!i) {
				const freqAsks = specialViewMap.frequentlyAsked({
					questions: [
						"Партнерство",
						"Освіта",
						"Статус замовлень",
						"Акції/промо",
					]
				});
				document.querySelector(".chat-container").appendChild(freqAsks);
			}
			
			i++;
		}		
	});
}